import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import Autocomplete from "@mui/material/Autocomplete";
import { FormField, FormActions } from "../util/formFields";

const ViewEditServiceConfig = ({ curRow, handleEditClose, emailList }) => {
  const { fetchServiceConfigsFromAllEnv } = useDataView();
  const values = curRow.original;

  const propertyValueArr = [];

  const propValue = values.PropertyValue.split(",");
  propValue.forEach(function (element) {
    propertyValueArr.push(element.toLowerCase());
  });

  const [formData, setFormData] = useState({
    _ServiceName: values.ServiceName,
    _PropertyName: values.PropertyName,
    PropertyValue: values.PropertyValue,
  });

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const handleAutoCompleteChange = ({ e, values }) => {
    let dbFormattedValue = values;
    if (values.length > 0) {
      dbFormattedValue = values.join();
    }

    setFormData((prevState) => ({
      ...prevState,
      PropertyValue: dbFormattedValue,
    }));
  };

  function handleSubmit(event) {
    event.preventDefault();
    const payload = [
      {
        _ServiceName: values.ServiceName,
        _PropertyName: values.PropertyName,
        PropertyValue: formData.PropertyValue,
      },
    ];

    if (formData.PropertyValue.length === 0) {
      NotificationManager.error(
        "Field can not be empty",
        "Service Config",
        10000
      );
    } else {
      const resourcePath = "integrations/cfg/serviceconfigs";

      API.UpdateRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          NotificationManager.success(
            "Record Updated",
            "Service Config",
            10000
          );
          fetchServiceConfigsFromAllEnv();
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });

      handleEditClose();
    }
  }

  return (
    <Box>
      <Stack spacing={0}>
        <FormField
          required
          id="ServiceName"
          name="ServiceName"
          label="Service Name"
          value={values.ServiceName}
          onChange={handleChange}
          disabled
        />
        <FormField
          required
          id="PropertyName"
          name="PropertyName"
          label="Property Name"
          value={values.PropertyName}
          onChange={handleChange}
          disabled
        />
        <Autocomplete
          id="PropertyValue"
          freeSolo
          multiple
          onChange={(e, values) => handleAutoCompleteChange({ e, values })}
          getOptionLabel={(option) => option}
          options={emailList}
          fullWidth
          defaultValue={propertyValueArr}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Property Value"
              name="PropertyValue"
              variant="outlined"
              size="small"
              fullWidth
              sx={{ mb: 2 }}
            />
          )}
        />
      </Stack>

      <FormActions>
        <Button variant="text" color="inherit" onClick={handleEditClose}>
          Close
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          Save
        </Button>
      </FormActions>
    </Box>
  );
};

export default ViewEditServiceConfig;
